<template>
  <div>
    <template v-for="(detail,index) in details"  >
      <div :key="index" >
        <template v-if="detail.apply_type == 1">
        <a-row
          type="flex"
          align="middle"
          :gutter="15"
          style="margin-bottom: 20px"
        >
          <a-col>
            <span style="height: 25px; border-left: 3px solid #35b5fe"></span>
          </a-col>
          <a-col>
            <b>支付工资</b>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">支付日期：{{ detail.verify_at }}</p>
          </a-col>
          <a-col :span="12">
            <p class="height-50">收款人员：{{ detail.name }}</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">
              证件类型：{{ detail.id_type | idFilter(detail.id_type) }}
            </p>
          </a-col>
          <a-col :span="12">
            <p class="height-50">证件号码：{{ detail.id_no }}</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">工资金额：{{ detail.apply_money }}元</p>
          </a-col>
          <a-col :span="12">
            <p class="height-50">
              支付方式：{{
                detail.settlement_type == 1 ? "账户余额" : "线下结算"
              }}
            </p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">收款方式：银行卡</p>
          </a-col>
          <a-col :span="12">
            <p class="height-50">收款账号：{{ detail.bank_card_no }}</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">支付备注：{{ detail.note }}</p>
          </a-col>
        </a-row>
      </template>
      <template v-if="detail.apply_type == 2">
        <a-row
          type="flex"
          align="middle"
          :gutter="15"
          style="margin-bottom: 20px"
        >
          <a-col>
            <span style="height: 25px; border-left: 3px solid #35b5fe"></span>
          </a-col>
          <a-col>
            <b>工资申请</b>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">
              申请状态：<span
                :class="
                  detail.status == 2 || detail.status == 3
                    ? 'red_status'
                    : 'blue_status'
                "
                >{{ detail.status | statusFilter(detail.status) }}</span
              >
            </p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">申请日期：{{ detail.create_at }}</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">申请人员：{{ detail.user_name }}</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="12">
            <p class="height-100">申请金额：{{ detail.apply_money }}元</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="24">
            <div class="flex_box_style">
              <div class="left_title">申请说明：</div>
              <div class="right_box">
                {{ detail.describe }}
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row type="flex" align="top">
          <a-col :span="24">
            <div class="flex_box_style">
              <div class="left_title">截图附件：</div>
              <div class="right_box">
                <template
                  v-if="detail && detail.img_list && detail.img_list.length > 0"
                >
                  <img
                    v-for="(item, index) in JSON.parse(detail.img_list)"
                    :key="index"
                    class="flex_image_item"
                    :src="item"
                    alt=""
                  />
                </template>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row v-if="detail.status == '0'">
          <a-col :span="24">
            <div class="flex_box_style">
              <div class="left_title"></div>
              <div class="right_box">
                <a-button
                  style="margin-right: 20px"
                  type="primary"
                  @click="payMoneys(detail)"
                  >支付工资</a-button
                >
                <a-button type="warning" @click="rejectApply"
                  >拒绝申请</a-button
                >
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row type="flex" align="top" v-if="detail.status == 1">
          <a-col :span="12">
            <p class="height-100">申请结果：同意并执行工资发放</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top" v-if="detail.status == 2">
          <a-col :span="12">
            <p class="height-100">申请结果：拒绝申请 <span style="color:red">原因：{{detail.reject_reason}}</span></p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top" v-if="detail.status == 1 || detail.status == 2">
          <a-col :span="12">
            <p class="height-100">处理日期：{{ detail.verify_at }}</p>
          </a-col>
        </a-row>
        <a-row type="flex" align="top" v-if="detail.status == 3">
          <a-col :span="12">
            <p class="height-100">撤回日期：{{ detail.cancel_at }}</p>
          </a-col>
        </a-row>
      </template>
      </div>
    </template>
    <PayDialog ref="payDialog"></PayDialog>
  </div>
</template>

<script>
import PayDialog from "../components/dialogs/payDialogDetail.vue";
import DividerBar from "@/components/dividerBar";
import "@/shared/plugins/element";
import Api from "@/api";
export default {
  components: {
    DividerBar,
    PayDialog,
  },
  filters: {
    statusFilter(status) {
      const obj = {
        0: "待审核",
        1: "审核通过",
        2: "审核拒绝",
        3: "已撤回",
      };
      return obj[status]
    },
    idFilter(status) {
      const obj = {
        1: "身份证",
        2: "港澳通行证",
        3: "台胞证",
      };
      return obj[status]
    },
  },
  props: {
    details: {
      type: Array,
      default: () => [],
    },
    order: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      close_reason: "",
    };
  },
  methods: {
    payMoneys(detail) {
      this.$refs.payDialog.open(this.order, "salary",detail);
    },
    rejectApply() {
      this.$msgbox({
        title: "请输入拒绝原因",
        message: (
          <textarea
            vModel={this.close_reason}
            style="width:97%;height:90px"
          ></textarea>
        ),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        /*
        let res = await Api.post.partTimeOrderList(params);
        */
        let res = await Api.post.salaryRefuse({
          settlement_apply_id: this.detail.id,
          reject_reason: this.close_reason,
        });
        if (res) {
          this.$message.success("操作成功");
          this.close_reason = "";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.flex_box_style {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
}
.left_title {
  width: 70px;
  white-space: nowrap;
  display: flex;
}
.right_box {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  font-size: 14px;
  .flex_image_item {
    width: 40px;
    height: 60px;
    margin-right: 10px;
  }
}
.red_status {
  color: #ff0000;
}
.blue_status {
  color: #1989ff;
}
</style>
